import { isObject } from 'underscore';

import { FetchError } from '@/connection/helpers';
import { GetProjectGroups } from '@/connection/projects/get-project-groups';
import { RootState } from '@/store/main';
import { serializeError } from '@/store/utils/serialize-error';
import { EventGroup, LoadingStatus } from '@/types/projects.types';
import { ProjectsReducerCreator } from '../types';

const loadProjectGroupsReducer = (create: ProjectsReducerCreator) => {
  return create.asyncThunk(
    async ({ channel }: { channel: number }, { rejectWithValue, getState }) => {
      try {
        const state = getState() as RootState;
        const projectGroups = state.projects?.projectGroups as EventGroup[] | null;
        if (projectGroups) return projectGroups;

        const result = await GetProjectGroups({ channel });
        if ('error' in result) {
          console.error('loadProjectGroups error', result.error);
          return rejectWithValue(serializeError(result.error));
        }
        return (result || []).filter((group) => group.event_uuids.length > 0);
      } catch (error) {
        if (error instanceof FetchError) {
          return rejectWithValue(error.message);
        }

        if (isObject(error)) {
          return rejectWithValue(serializeError(error));
        }

        throw error;
      }
    },
    {
      pending: (state) => {
        state.loadingProjectGroupsStatus = LoadingStatus.Loading;
      },
      fulfilled: (state, action) => {
        state.projectGroups = action.payload;
      },
      settled: (state) => {
        state.loadingProjectGroupsStatus = LoadingStatus.Done;
      },
    }
  );
};

export default loadProjectGroupsReducer;
